import { Component, OnDestroy, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-regulatory-investigations-form',
    templateUrl: './regulatory-investigations-form.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]]
        }
    ]
})
export class RegulatoryInvestigationsFormComponent implements OnInit, OnDestroy {
    formControlName = 'regulatoryInvestigations';
    formGroup!: UntypedFormGroup;
    private readonly subscriptions = new Subscription();

    constructor(public parent: FormGroupDirective, private readonly formBuilder: UntypedFormBuilder) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({});
        (this.parent.form.get('advisedSeriousIncident') as UntypedFormGroup).addControl(this.formControlName, this.formGroup);
    }

    ngOnDestroy() {
        //if a formGroup already exists in the parent when ngOnInit runs, new formGroup wouldn't work properly
        (this.parent.form.get('advisedSeriousIncident') as UntypedFormGroup).removeControl(this.formControlName);
        this.subscriptions.unsubscribe();
    }
}
